module.exports = __webpack_public_path__ + "img/about-main-2-mob.be06b49b.jpg";